import { render } from "./Portfolio.vue?vue&type=template&id=073540dd&scoped=true&ts=true"
import script from "./Portfolio.vue?vue&type=script&lang=ts"
export * from "./Portfolio.vue?vue&type=script&lang=ts"

import "./Portfolio.vue?vue&type=style&index=0&id=073540dd&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\nahue\\OneDrive\\Escritorio\\Proyectos\\SWMOTORES\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073540dd"]])

export default __exports__